import "./App.css";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Layout from "./components/Layout/Layout.jsx";
import DataProvider from "./context/data-context.js";
import { CartProvider } from "./context/cart-context.js";
import { WishlistProvider } from "./context/wishlist-context.js";
import { Navigator } from "./navigation/Navigator.jsx";
import AuthProvider from "./context/auth-context.js";

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          <WishlistProvider>
            <DataProvider>
              <Layout>
                <Navigator />
              </Layout>
            </DataProvider>
          </WishlistProvider>
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
